/**
 *
 * @param {number} width
 * @param {number} height
 * @param {number} targetWidth
 * @param {number} targetHeight
 * @param {boolean} expand
 * @return {{width: number, height: number}}
 */
import { colorToArray } from './ColorUtils';
import { ZoneType } from '../api/static/zones';
import { fitArea } from './ImageUtils';

export { fitArea };

export const ZoneCustomizationCustomConfigProps = Object.freeze([
  'x',
  'y',
  'scaleX',
  'scaleY',
  'rotation',
]);

/**
 *
 * @param fillColor
 * @param emptyColor
 * @param threshold
 * @return {function(...[*]=)}
 */
export function screenPrintingFilter(fillColor, emptyColor, threshold = 128) {
  const fillColorArray = colorToArray(fillColor);
  const emptyColorArray = colorToArray(emptyColor);

  if (fillColorArray[3] === undefined) {
    fillColorArray[3] = 255;
  }

  if (emptyColorArray[3] === undefined) {
    emptyColorArray[3] = 255;
  }

  return function (imageData) {
    const { data } = imageData;

    for (let i = 0, len = data.length; i < len; i += 4) {
      // i => red value
      // i + 1 => green value
      // i + 2 => blue value
      // i + 3 => alpha value

      // Find brightness
      // shade of gray based on luminosity
      // See https://docs.gimp.org/2.6/en/gimp-tool-desaturate.html
      // Luminosity = 0.21 × R + 0.72 × G + 0.07 × B
      const brightness =
        0.21 * data[i] + 0.72 * data[i + 1] + 0.07 * data[i + 2];

      const selectedColorArray =
        data[i + 3] > threshold && brightness < threshold
          ? fillColorArray
          : emptyColorArray;

      data[i] = selectedColorArray[0];
      data[i + 1] = selectedColorArray[1];
      data[i + 2] = selectedColorArray[2];
      data[i + 3] = selectedColorArray[3];
    }
  };
}

/**
 *
 * @param a
 * @param b
 * @return {number}
 * @deprecated
 */
export function sortLayers(a, b) {
  if (a.type === b.type) {
    return 0;
  } else if (a.type === ZoneType.TEXT) {
    return 1;
  } else {
    return -1;
  }
}
